<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="row ">
    <div class="col-12">
      <h4 class="mb-2 py-1 font-header-1">Payer</h4>
    </div>
  </div>
  <div class="row mb-2 " *ngIf="!AddGrp && !isUpdate">
    <div class="col">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pb-0 pt-2 mb-4">
          <div class="row mb-2">
            <div class="col-6">
              <button type="button" class="btn btn-sm" (click)="clearRelations();GrpCreateupdate('new')"
                *ngIf="fp.payercreate">Add
                Payer</button>
            </div>
            <div class="col-6 ">
              <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
                <i class="fa fa-repeat"> Refresh </i>
              </button>
            </div>
          </div>

          <div class="row mt-2 " *ngIf="!AddGrp && !isUpdate" style="min-height: 500px;">
            <div class="col">
              <!-- ejs-grid -->
              <ejs-grid #gridPayer [dataSource]='GridList | async' [allowPaging]='true'
                [pageSettings]='initialPayerPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                [allowResizing]='true' (dataStateChange)='dataChangePayer($event)' [showColumnChooser]='true'
                (actionBegin)="onActionPayer($event)" [allowSorting]='true'>
                <e-columns>
                  <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <!-- <button class="btn btn-edit-table" data-bs-toggle="modal"
                                    data-bs-target="#CreatePayermodal" (click)="getDetails(data)"><i
                                        class="fa fa-edit"></i></button>&nbsp; -->
                      <button class="btn btn-edit-table" (click)="getDetails(data);GrpCreateupdate('edit');"
                        *ngIf="fp.payerupdate"><i class="fa fa-edit"></i></button> &nbsp;
                      <button class="btn btn-delete-table" data-bs-toggle="modal" data-bs-target="#deletePayermodal"
                        (click)="getDetails(data)"><i class="fa fa-trash" *ngIf="fp.payerdelete"></i></button>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="group_LovName" headerText="Group Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>

                  <e-column minWidth=100 field="billingFullName" headerText="Billling Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="payorName" headerText="Payer Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="addressLine1" headerText="AddressLine1" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="addressLine2" headerText="AddressLine2" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="city" headerText="City" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="state" headerText="State" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="phoneNumber" headerText="PhoneNumber" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="defaultBillType" headerText="DefaultBillType" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="i837PInsType_LovName" headerText="i837PInsType Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>


                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div>
                        <span id='show' (click)='showPayerColumns()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                          </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="AddGrp||isUpdate && global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''  && global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
  <form [formGroup]="PayerInfoForm">
    <div class="row mb-2">
      <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
          <div class="card-header transparent  text-muted">
            <div class="row">
              <div class="col-6">
                <h4 class="mb-0 font-header" *ngIf="!isUpdate">New Payor</h4>
                <h4 class="mb-0 font-header" *ngIf="isUpdate">Update Payor</h4>
              </div>
              <div class="col-6 mt-2">
                <span class="text-right"><button type="button" class="btn btn-sm " (click)="cancel()">Close</button>
                  &nbsp;&nbsp;&nbsp;</span>
                <!-- <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                                (click)="clearRelations()">Cancel</button> -->
                <span class="text-right me-2 pe-2">
                  <button class="btn btn-sm text-right" *ngIf="!isUpdate" [disabled]="!PayerInfoForm.valid || isSaveorUpdateBoolean"
                    (click)="SaveOrUpdateGroupPayor()">
                    Save
                  </button>&nbsp;&nbsp;&nbsp;
                  <button class="btn btn-sm text-right" (click)="SaveOrUpdateGroupPayor();" *ngIf="isUpdate"
                    [disabled]="!PayerInfoForm.valid || isSaveorUpdateBoolean">
                    Update & Close
                  </button>
                  &nbsp;&nbsp;&nbsp;
                </span>



              </div>
            </div>
          </div>
          <div class="card-body  widget-body pt-2">
            <!-- <div class="row alert ml-3 mr-3 alert-warning  text-dark" *ngIf="showErrorAlert==true">
                <strong>{{error}}</strong>
              </div> -->
            <div class="row mt-2">
              <div class="col-lg-8">
                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">Payer Name<sup class="super-script">*</sup></label>
                    <input type="text" class="form-control" formControlName="PayorName"
                      [(ngModel)]="savePayerInfo.payorName">
                  </div>
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">Billing Name<sup class="super-script">*</sup></label>
                    <input type="text" class="form-control" formControlName="BillingFullName"
                      [(ngModel)]="savePayerInfo.billingFullName">
                  </div>
                </div>


                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">Payer Type<sup class="super-script">*</sup></label>
                    <select class="form-control" [(ngModel)]="savePayerInfo.groupLid" formControlName="PayerTypes">
                      <option [value]="items.id" *ngFor="let items of PayerList">
                        {{items.lovName}}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">Billing Payer Id<sup class="super-script">*</sup></label>
                    <input type="text" class="form-control" [(ngModel)]="savePayerInfo.payorId"
                      formControlName="BillingPayerId">

                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">Address Line 1</label>
                    <input class=" form-control" type="text" [(ngModel)]="savePayerInfo.addressLine1"
                      formControlName="AddressLine1">
                  </div>
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">Address Line 2</label>
                    <input class=" form-control" type="text" [(ngModel)]="savePayerInfo.addressLine2"
                      formControlName="AddressLine2">
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">Phone Number</label>
                    <input class=" form-control" type="text" [(ngModel)]="savePayerInfo.phoneNumber"
                      formControlName="phoneNumber" (keypress)="keyPress($event)"
                      (ngModelChange)="DemographicPhoneFormat()" minlength="14" maxlength="14">


                  </div>
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">City</label>
                    <input class="form-control" [(ngModel)]="savePayerInfo.city" formControlName="City">
                  </div>
                </div>


                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">State</label>
                    <div class="col-lg-7">
                      <ng-select [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                        bindLabel="name" bindValue="abbreviation" [(ngModel)]="savePayerInfo.state"
                        formControlName="State">
                      </ng-select>
                    </div>

                  </div>
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">Zip</label>
                    <input class="form-control" [(ngModel)]="savePayerInfo.zip" (keypress)="keyPress($event)"
                      minlength="5" maxlength="10" formControlName="Zip">
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">Default Bill Type</label>
                    <input class="form-control" [(ngModel)]="savePayerInfo.defaultBillType"
                      formControlName="DefaultBillType">
                  </div>
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">Claim Filling Ind<sup class="super-script">*</sup></label>

                    <input class="form-control" [(ngModel)]="savePayerInfo.claimFilingIndicatorCode"
                      formControlName="ClaimFillingCode">

                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold w-75">NPI</label>
                    <input class="form-control" [(ngModel)]="savePayerInfo.npi" formControlName="NPI">
                  </div>

                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">i837PInsType<sup class="super-script">*</sup></label>
                    <select class="form-control" [(ngModel)]="savePayerInfo.i837PInsTypeLid"
                      formControlName="i837PInsType">

                      <option [value]="i837PInsTypeName.id" *ngFor="let i837PInsTypeName of i837PInsTypeList">
                        {{i837PInsTypeName.lovCode}}</option>
                    </select>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                  </div>

                  <div class="col-lg-6 col-md-6 d-inline-flex ">
                    <label class=" me-1 label-bold  w-75">ATYPICAL</label>
                    <div class="col-lg-7">
                      <input class="checkbox checkbox-primary styled" formControlName="ATYPICAL" type="checkbox"
                        [(ngModel)]="savePayerInfo.atypical">
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <hr />
            <div class="row ">
              <div class="col-lg-10">

                <label class="font-header">Insurance type,Claim filling indicator, Other ref code type aNumber
                  and a Group number are used for ANSI 837 electronic billing</label>
              </div>
              <div class="col-lg-2">
                <button type="button" class="btn btn-sm float-end" [disabled]="!enableTab" data-bs-toggle="modal"
                  data-bs-target="#companymodal" (click)="assigncompanyTable()">Assign Company
                </button>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="mt-2">
                  <ejs-grid #grid [dataSource]='companyMappedArray' [allowResizing]='true'>
                    <e-columns>
                      <e-column minWidth=100 headerText="Actions">
                        <ng-template #template let-data>
                          <button class="btn btn-edit-table mr-1" (click)="updateCom(data)" data-bs-toggle="modal"
                            data-bs-target="#updatemodal"><i class="fa fa-edit"></i></button>&nbsp;&nbsp;&nbsp;
                          <button class="btn btn-delete-table" data-bs-toggle="modal"
                            data-bs-target="#deletemodalcompany" (click)="DeleteCom(data)"><i
                              class="fa fa-trash"></i></button>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="companyName" headerText="Company">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="providerNo" headerText="Provider Number">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <!--                       
                        <e-column minWidth=100 field="companyName" headerText="Bill To/ Pay To Company Name">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column> -->
                      <e-column minWidth=100 field="street" headerText="Street">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="city" headerText="City">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="state" headerText="State">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="zipCode" headerText="Zip Code" type="number"></e-column>
                      <e-column minWidth=100 field="statusName" headerText="Status">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>

                    </e-columns>
                  </ejs-grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Close Modal -->
<span id="openModal2" data-bs-target="#CloseModal" data-bs-toggle="modal"></span>
<div class="modal" id="CloseModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Close</h4>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">

        You want to close without save?
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" (click)="cancelYes()">Yes</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal">No</button>
      </div>

    </div>
  </div>
</div>

<!-- Assign company modal -->
<span id="openModal3" data-bs-target="#companymodal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="companymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Assign Company</h5>
      </div>
      <div class="modal-body ">
        <div class="row">
          <ejs-grid #grid class="modal-table mx-auto" [dataSource]='companyList' [allowResizing]='true'>
            <e-columns>
              <e-column minWidth=100 headerText="Select">
                <ng-template #template let-data>
                  <input type="radio" [(ngModel)]="radio" id="radio" [value]="data.id"
                    (change)="selectCompany($event,data);" name="data" class="mx-auto" data-bs-toggle="modal"
                    data-bs-target="#updatemodal">
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="companyName" headerText="CompanyName"></e-column>
              <e-column minWidth=100 field="city" headerText="City"></e-column>
              <e-column minWidth=100 field="street" headerText="Street"></e-column>
              <e-column minWidth=100 field="state" headerText="State"></e-column>
              <e-column minWidth=100 field="fax" headerText="Fax"></e-column>
              <e-column minWidth=100 field="zipCode" headerText="ZipCode"></e-column>
              <e-column minWidth=100 field="fein" headerText="FEIN"></e-column>
              <e-column minWidth=100 field="StatusLid" headerText="Status"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="reset_filter()">Close</button>
      </div>
    </div>
  </div>
</div>

<span id="openModal4" data-bs-target="#updatemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="updatemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">

        <h5>Update Company</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <form [formGroup]="CompanyGroup">
        <div class="modal-body">

          <div class="row alert ml-3 mr-3 alert-warning text-dark" *ngIf="comAlert==true">
            <strong>{{comError}}</strong>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label class="label-bold">Provider No
                <sup class="super-script">&nbsp;*</sup>
              </label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="providerNo"
                [(ngModel)]="GroupPayorCompanyMapping.providerNo" name="providerNo">
            </div>
          </div>         
          <div class="row">
            <div class="col-lg-6">
              <label class="label-bold">Taxonomy Code
              </label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="taxonomyCode"
                [(ngModel)]="GroupPayorCompanyMapping.taxonomyCode" name="taxonomyCode">
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <label class="label-bold">Payer Initial
              </label>
            </div>
            <div class="col-lg-6">
              <ng-select  [(ngModel)]="GroupPayorCompanyMapping.payerInitialLid" formControlName="payerInitialLid"  bindLabel="lovName" bindValue="id" [items]="PayerInitialList">                
              </ng-select>
            </div>

          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn me-2" [disabled]="!CompanyGroup.valid || isSaveorUpdateBoolean"
          (click)="saveCompany(GroupPayorCompanyMapping);reset_filter()">Update & Close</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal">close</button>

      </div>
    </div>
  </div>
</div>
<!-- For Delete Modal -->
<span id="closePayerModal" data-bs-target="#deletePayermodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletePayermodal" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button> -->

      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="DeletePayer()" data-bs-dismiss="modal">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" (click)="clearRelations()" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- DeleteModal -->
<span id="openModal5" data-bs-target="#deletemodalcompany" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodalcompany" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Delete Record</h5>
        <!-- <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span> 
        </button>-->
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal"
          (click)="deleteGroupCompanyMapping()">Delete</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal" (click)="reset_filter()">Cancel</button>
      </div>
    </div>
  </div>
</div>





<!-- Add Group payor -->